import React from 'react';

class List extends React.Component {
  render() {
    const { text, icon } = this.props;

    return (
      <section className="list">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-lg-6">
              {text}
            </div>
            <div className="col-md-3 col-lg-6 list__icon">
              { icon &&
                <img src={icon} alt="Icon" />
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default List;



// WEBPACK FOOTER //
// ./src/components/list/index.js